import { inject } from '@angular/core';
import { map } from 'rxjs/operators';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { UnauthenticatedPath, UnauthorisedPath } from 'src/app/core/routes/error.routes';
import { AppcoreService } from 'src/app/shared/services/appcore';

export const AuthenticationGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
  const router = inject(Router);
  const appcoreService = inject(AppcoreService);

  return appcoreService.isAuthenticated().pipe(
    map(authenticated => authenticated || router.parseUrl(`/${UnauthenticatedPath}`)),
  );
};

export const AuthorisationGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
  const router = inject(Router);
  const appcoreService = inject(AppcoreService);

  return appcoreService.isAuthorised().pipe(
    map(authenticated => authenticated || router.parseUrl(`/${UnauthorisedPath}`)),
  );
};
